export const newsletterQueryKeys = {
  all: (agencyId: string) => ["newsletters", agencyId],
  statistics: (agencyId: string, date: string) => [
    ...newsletterQueryKeys.all(agencyId),
    "statistics",
    date,
  ],
};
